// Imports:

// Styles:
import 'bootstrap/scss/bootstrap.scss'
import 'choices.js/public/assets/styles/choices.min.css'

// Main.scss should always be last, otherwise your styles can be overwrite by styles from libraries
import '../scss/main.scss'

// Popper - neccessary for bootstrap
import '@popperjs/core'

// Common libraries:
import $ from 'jquery'
window.jQuery = $
window.$ = $

import 'bootstrap'

// Tippy
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import 'tippy.js/themes/light.css'

// Plugins
import './plugins/PluginLoadDependecies.ts'
import './plugins/PluginAnalyticsDataLayer.ts'
import './plugins/PluginLazyLoad.js'
import './plugins/PluginSVGConverter.ts'
import './plugins/outline.js'
import './plugins/PluginBlockEmbed.ts'
import './plugins/PluginAnalytics.ts'
import { CookiesController } from './plugins/PluginCookies.ts'

// Components:
import './components/ComponentVideo.ts'
import './components/ComponentHeader.ts'
import './components/ComponentLightbox.ts'
import './components/ComponentSmoothScroll.ts'
import animate from './components/ComponentAnimation.ts'
animate({
  name: 'vp',
  options: {
    root: null,
    threshold: 0,
    rootMargin: `0px 0px -${window.innerHeight * 0.22}px 0px`,
  },
})
import './components/ComponentForm.js'

// Create CookiesController instance
window.CookiesController = new CookiesController()

// Script to handle menuPages
// Handle show/hide of menu with all pages

// Get menu element
let BwMenuPages = $("[data-item='BW-navigation-menu']")

// Check if menu exists
if (BwMenuPages.length > 0) {
  // Show/hide on button with menu icon
  $("[data-item='BW-navigation-button']").on('click', () => {
    if (BwMenuPages.length > 0) {
      // Check if menu is visible
      if (BwMenuPages.hasClass('visible') !== true) {
        // If true -> animate show
        BwMenuPages.addClass('visible')
        BwMenuPages.animate({ opacity: '1' }, 300)
      } else {
        // If false -> animate hide
        BwMenuPages.animate({ opacity: '0' }, 300, function () {
          BwMenuPages.removeClass('visible')
        })
      }
    }
  })

  // Hide on button 'X" click
  $("[data-action='BW-navigation-hide']").on('click', () => {
    if (BwMenuPages.length > 0) {
      // Animate hide
      BwMenuPages.animate({ opacity: '0' }, 300, function () {
        BwMenuPages.removeClass('visible')
      })
    }
  })
}

// Block video click
$('video').bind('contextmenu', function () {
  return false
})

// Remove preload class on load
// Remove preload class on load
window.addEventListener('load', () => {
  // Check if there is hash in link, if true and section with such id exists, move page to top
  const linkHash = window.location.hash
  if (linkHash) {
    // If there is hash, find right element
    const hashElement = document.getElementById(linkHash.split('#')[1])
    if (hashElement) {
      // If there is such element, animate scroll to top
      $('html').animate(
        {
          scrollTop: 0,
        },
        10,
      )
    }
  }

  const submitForms = document.querySelectorAll(
    '[data-submit-form]',
  ) as NodeListOf<HTMLFormElement>
  if (submitForms.length > 0) {
    submitForms.forEach((submitForm) => {
      const submitButton = submitForm.querySelector(
        '[type="submit"]',
      ) as HTMLButtonElement

      if (submitButton) {
        submitButton.onsubmit = (e) => {
          e.preventDefault()
          e.stopPropagation()

          return false
        }

        submitButton.addEventListener('click', (e) => {
          e.preventDefault()

          if (submitForm.checkValidity() === false) {
            submitForm.reportValidity()
            return
          }

          submitForm.submit()
        })
      }
    })
  }

  // Init tooltip
  $("[data-item='tooltip']").tooltip({
    template: '<div class="tooltip"><div class="tooltip-inner"></div></div>',
  })

  // hide loader
  let loader = $("[data-item='loader']")
  loader.animate({ opacity: 0 }, 300, () => {
    loader.addClass('hidden')

    // #Animate scroll to section if there is anchor in url
    // Check if there is hash in link
    const linkHash = window.location.hash
    if (linkHash) {
      // If there is hash, find right element
      const hashElement = document.getElementById(linkHash.split('#')[1])
      if (hashElement) {
        // Calculate distance to scroll
        let distance = findPos(hashElement)

        if (!distance) return

        // Different distance for header for different screens
        if (window.innerWidth < 992) {
          distance -= 75
        } else {
          distance -= 275
        }

        //Finds y value of given object
        function findPos(obj: HTMLElement) {
          var curtop = 0
          if (obj.offsetParent) {
            do {
              curtop += obj.offsetTop
            } while ((obj = obj.offsetParent as HTMLElement))
            return curtop
          }
        }

        // If there is such element, animate scroll to
        $('html').animate(
          {
            scrollTop: distance,
          },
          750,
        )
      }
    }
  })

  // Get body
  document.getElementsByTagName('body')[0].classList.remove('preload')
})

document.addEventListener('DOMContentLoaded', function () {
  console.log(
    window.CookiesController.isCookieAccepted('bw-cookie-google-analytics'),
  )
  if (
    window.CookiesController &&
    window.CookiesController.isCookieAccepted('bw-cookie-google-analytics')
  ) {
    document
      .querySelectorAll('script[data-cookie-google-analytics]')
      .forEach(function (el) {
        var script = document.createElement('script')

        if (el.getAttribute('src')) {
          script.src = el.getAttribute('src')
        }

        if (el.innerHTML != '') {
          script.innerHTML = el.innerHTML || ''
        }

        // Copy any other needed attributes from the original script
        if (el.getAttribute('async') !== null) script.async = true
        if (el.getAttribute('defer') !== null) script.defer = true
        document.body.appendChild(script)
      })
  }
})
